import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { PropTypes } from 'mobx-react'

import ReactFitText from 'react-fittext'
import { ImageHeader, ImageHeading } from '../components/OnePager/ImageSectionStyle'
import { NavSpacer, LightBackground, Black } from '../components/GeneralStyle'

import headerImage from '../images/impressum_headerimage.jpg'


class Dataprivacy extends Component {

  componentWillMount() {
    // let all components know that this is the page home
  }

  render() {

    return (
      <div>

        <Grid fluid>
          <NavSpacer />
          <LightBackground className={"fillScreen"}>
            <ImageHeader height={350} background={headerImage}>
              <ReactFitText
                maxFontSize={30}
                compressor={1.8}>
                <ImageHeading>DATENSCHUTZERKLÄRUNG</ImageHeading>
              </ReactFitText>
            </ImageHeader>


            <Row style={{ padding: 60 }}>
            <div className={'content-wrapper'} style={{ maxWidth: 1200}}>>
              <Black>Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.</Black>
              <br />
              <h5 style={{ color: "black" }}> Kontakt mit uns </h5>
              <Black>Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen zwei Jahre bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</Black>
              <br />
              <h5 style={{ color: "black" }}> Datenspeicherung </h5>
              <Black>Wir weisen darauf hin, dass zum Zweck des einfacheren Verwaltung und Abwicklung des Vertragsverhältnisses Name, Anschrift und weitere personenbezogenen Daten gespeichert werden, welche Sie über die Plattform angeben.
                Die von Ihnen bereit gestellten Daten sind zur Vertragserfüllung bzw zur Durchführung vorvertraglicher Maßnahmen erforderlich. Ohne diese Daten können wir den Vertrag mit Ihnen nicht abschließen. Eine Datenübermittlung an Dritte erfolgt nicht, mit Ausnahme der Übermittlung etwaiger Kreditkartendaten an die abwickelnden Bankinstitute/Zahlungsdienstleister zum Zwecke der Zahlungsabwicklung, an das von uns beauftragte Transportunternehmen/Versandunternehmen zur Zustellung der Ware sowie an unseren Steuerberater zur Erfüllung unserer steuerrechtlichen Verpflichtungen.
                Nach Beendigung des Vertragsverhältnisses werden die bei uns gespeicherten Daten gelöscht. Im Falle eines Vertragsabschlusses werden sämtliche Daten aus dem Vertragsverhältnis bis zum Ablauf der steuerrechtlichen Aufbewahrungsfrist (7 Jahre) gespeichert.
            Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) und/oder lit b (notwendig zur Vertragserfüllung) der DSGVO.</Black>
              <br />
              <h5 style={{ color: "black" }}> Cookies</h5>
              <Black>Unsere Website verwendet so genannte Cookies, welche jedoch NICHT personenbezogen sind. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an.
                  Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
                  Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben.
                  Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.
            </Black> <br />
              <h5 style={{ color: "black" }}> Web Analyse</h5>
              <Black>Unsere Website verwendet Funktionen des Webanalysedienstes Google Inc. („Google“), wofür Daten in die Vereinigten Staaten von Amerika übertragen werden können. Dazu werden nicht personenbezogene Cookies verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer ermöglicht. Die dadurch erzeugten Informationen werden auf den Server des Anbieters übertragen und dort gespeichert.
                  Sie können dies verhindern, indem Sie Ihren Browser so einrichten, dass keine Cookies gespeichert werden.
          Wir haben mit dem Anbieter einen entsprechenden Vertrag zur Auftragsdatenverarbeitung abgeschlossen.</Black>
              <br />
              <Black>Auf Basis der Rechtsgrundlage „berechtigtes Interesse wird Ihre IP-Adresse erfasst, aber umgehend pseudonymisiert. Dadurch ist nur mehr eine grobe Lokalisierung möglich.Die Beziehung zum Webanalyseanbieter basiert auf einem Angemessenheitsbeschluss der Europäischen Komission im Sinne des „Privacy Shield“.
              Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.
              Unser Anliegen im Sinne der DSGVO (berechtigtes Interesse) ist die Verbesserung unseres Angebotes und unseres Webauftritts. Da uns die Privatsphäre unserer Nutzer wichtig ist, werden die Nutzerdaten pseudonymisiert. Die Nutzerdaten werden für die Dauer von maximal 6 Monaten aufbewahrt.
          </Black> <br />
              <h5 style={{ color: "black" }}> Newsletter & E-Mail Benachrichtigungen </h5>
              <Black>Zur Erfüllung etwaiger Informationspflichten, die sich aus dem Vertragsverhältnis ergeben, senden wir Ihnen Benachrichtigungen via Mail (bspw. zu getätigten Buchungen, Nachrichten, etc) zu. Des Weiteren haben Sie die Möglichkeit, über unsere Website unseren Newsletter zu abonnieren. Hierfür benötigen wir Ihre E-Mail-Adresse und ihre Erklärung, dass Sie mit dem Bezug des Newsletters einverstanden sind. Um Sie zielgerichtet mit Informationen zu versorgen, erheben und verarbeiten wir außerdem freiwillig gemachte Angaben. Das Abo des Newsletters können Sie jederzeit stornieren. Senden Sie Ihre Stornierung bitte an folgende E-Mail-Adresse: <a href="mailto:kontakt@the-loge.com">kontakt@the-loge.com</a>. Wir löschen anschließend umgehend Ihre Daten im Zusammenhang mit dem Newsletter-Versand.
      </Black>
              <br />
              <h5 style={{ color: "black" }}> Ihre Rechte </h5>
              <Black>Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren. In Österreich ist dies die Datenschutzbehörde.
          </Black>
              <br />
              <h5 style={{ color: "black" }}> Sie erreichen uns unter folgenden Kontaktdaten </h5>
              <Black>The Loge GmbH </Black>
              <Black>Badeteich Hofstädter 8a</Black>
              <Black>AT-2353 Guntramsdorf</Black>
              <Black>Tel: +43 676 944 44 81</Black>
              <Black>E-Mail: kontakt@the-loge.com</Black>

              </div>
            </Row>
          </LightBackground>
        </Grid>

      </div >
    );
  }
}

Dataprivacy.propTypes = {
  appStore: PropTypes.observableObject
};

export default Dataprivacy;



// WEBPACK FOOTER //
// /src/pages/Dataprivacy.js